




























import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { format, parseISO } from "date-fns";
import debounce from "debounce";
import XLSX from 'xlsx';
import { eachDayOfIntervalWithOptions } from "date-fns/fp";

@Component({})
export default class EntityTable extends Vue {
  @Prop() title: string;
  @Prop() model: any;
  @Prop() columns: string[];
  //Para mudar os labels da grid
  @Prop() headers: string[];
  @Prop() exportColumns: string[];
  //para mudar os labels da planilha de exportação
  @Prop() exportHeaders: string[];
  @Prop({ default: 20 }) pageLimit: number;
  @Prop({ default: () => {} }) filter: any;
  @Prop({ default: true }) enableCreation: boolean;
  @Prop({ default: false }) readOnly: boolean;
  @Prop({ default: false }) multiple: boolean;
  @Prop({ default: false }) disableAutoSearch: boolean;
  @Prop({ default: true }) enableExport: boolean;
  @Prop({ default: false }) enableImport: boolean;
  @Prop({ default: "Importar "}) importCaption: string;
  @Prop() importFunction: Function;

  @Prop({ default: () => [] }) actions: {
    name: string,
    icon: string,
    color: string,
    action: any,
  }[];

  entityDescription: any = [];

  // current search state
  currentPage: number = 1;
  currentSearchTerm: string = "";
  currentSortKey: string = "";
  currentSortDirection: string | null = null;
  currentTotal: number = 0;

  results: any = [];
  selectedRows: any = []; // if multiple selection is disable, this becomes an object

  created() {
    this.handleSearch = debounce(this.handleSearch, 400);
  }

  async mounted() {
    this.entityDescription = await this.model.getDescription();
    //console.log("logD entity description", this.entityDescription)
    if (!this.disableAutoSearch) {
      this.handleSort("", null); // initialize default sort and perform initial search
    }
  }

  get tableFields(): any[] {
    if (!this.entityDescription) {
      return [];
    }
    const result = this.entityDescription.filter((fieldDescription: any) => this.columns.includes(fieldDescription.key));

    //Respeitar a ordem do array this.columns para exibir as colunas da grid, estava sendo ordenado pela definição dos campos no entity da api
    const fields = [];
    for (let i = 0; i < this.columns.length; i++) {
      const exists = result.find((r: any) => this.columns[i].includes(r.key));
      if (exists !== null && exists !== undefined) {
        console.log('get table fields', exists);
        try {
          if (this.headers && this.headers.length === this.columns.length) {
            exists.name = this.headers[i];
          }
        }
        catch (e) {
          console.log('get field exception', e);
        }
        fields.push(exists);
      }
    }

    //console.log('ordered columns', fields);

    return fields;
  }

  get exportFields(): any[] {
    if (!this.entityDescription) {
      return [];
    }

    //verificar se as colunas e headers para exportação foram definidas
    const columns = this.exportColumns && this.exportColumns.length > 0 ? this.exportColumns: this.columns;
    const headers = this.exportHeaders && this.exportHeaders.length > 0 ? this.exportHeaders: this.headers;

    //console.log('columns', columns);
    //console.log('headers', headers);

    const result = this.entityDescription.filter((fieldDescription: any) => columns.includes(fieldDescription.key));    
    //Respeitar a ordem do array this.exportColumns ou this.columns (caso  primeiro não exista) para montar as colunas da planilha, estava sendo ordenado pela definição dos campos no entity da api
    const fields = [];
    for (let i = 0; i < columns.length; i++) {
      const exists = result.find((r: any) => columns[i] === r.key);
      if (exists !== null && exists !== undefined) {
        if (headers && headers.length === columns.length) {
          exists.name = headers[i];
        }
        fields.push(exists);
      }
    }

    //console.log('ordered columns', fields);
    return fields;
  }

  getFieldContent(field: any, fieldKey: string, fieldData: any) {
    switch (field.kind) {
      case "select":
        return fieldData[fieldKey] ? field.options.find((option: any) => option.value === fieldData[fieldKey]).name : "-";
      case "date":
        return fieldData[fieldKey] ? format(parseISO(fieldData[fieldKey].replace('Z','')), "dd/MM/yyyy HH:mm") : "-";
      case "relation":
        return fieldData[`${fieldKey}.name`];
    }
    return fieldData[fieldKey];
  }

  async handleSearch(term: string) {
    console.log('search', term, this.currentSortKey);
    if (!this.currentSortKey) {
      return;
    }

    //console.log("filter: ", this.filter);
    //if (this.filter.startDateTime) {
    Object.keys(this.filter).forEach(filtro => {
      //console.log("filter startDateTime: ", this.filter.startDateTime);
      //console.log("filtro key: ", filtro);
      if (this.filter[filtro] && this.filter[filtro].$between) {
        //console.log(`filter ${this.filter[filtro]}.$between: `, this.filter[filtro].$between);
        try {
          this.filter[filtro].$between[0].setHours(0,0,0);
          this.filter[filtro].$between[1].setHours(23,59,59);
          //console.log("filter startDateTime.$between after try: ", this.filter.startDateTime.$between);
        } catch {
          //console.log("filter startDateTime.$between oncatch: ", this.filter.startDateTime.$between);
          this.filter[filtro].$between[0] = new Date(this.filter[filtro].$between[0]);
          this.filter[filtro].$between[0].setHours(0,0,0);
          this.filter[filtro].$between[1] = (new Date(this.filter[filtro].$between[1]));
          this.filter[filtro].$between[1].setHours(23,59,59);          
          //console.log("filter startDateTime.$between after catch: ", this.filter.startDateTime.$between);
        }
        this.filter[filtro].$between[0].setHours(this.filter[filtro].$between[0].getHours() - 3);
        this.filter[filtro].$between[1].setHours(this.filter[filtro].$between[1].getHours() - 3);
        //console.log("filter startDateTime.$between after all: ", this.filter.startDateTime.$between);
      }    
    });
    // console.log("logD entity description", JSON.stringify(this.entityDescription));
    // console.log("logD columns", JSON.stringify(this.columns))    
    // console.log('logD handlesearch', JSON.stringify(this.tableFields));
    this.currentSearchTerm = term;
    const queryParameters = {
      page: this.currentPage,
      limit: this.pageLimit,
      sort: [{
        field: this.currentSortKey,
        order: this.currentSortDirection,
      }],
      search: {
        ...this.filter,
        $or: this.tableFields.filter(field => field.kind !== 'relation' && field.kind !== 'action').map(field => ({
          [field.key]: {
            $cont: this.currentSearchTerm,
          },
        })),
      },
      join: this.entityDescription.filter((fieldDescription: any) => fieldDescription.kind === 'relation' && this.tableFields.find(field => fieldDescription.key === field.key || fieldDescription.key === field.join)).map((fieldDescription: any) => ({ field: fieldDescription.key })),
    };
    this.$vs.loading();
    try {
      console.log(queryParameters);
      const response = await this.model.search(queryParameters);
      console.log(response);
      this.currentTotal = response.total;
      // keep reference to currently selected rows by id
      this.results = response.data.map((entity: any) => this.selectedRows.find((row: any) => row.id === entity.id) || entity);
      //console.log('results', this.results);
      // padding workaround due to broken server side table implementation
      // const leftPaddedResults = Array(this.pageLimit * (this.currentPage - 1)).map(() => ({})).concat(response.data); // left pad results with blank rows
      // this.results = leftPaddedResults.concat(Array(this.currentTotal - leftPaddedResults.length).map(() => ({}))); // right pad results until total length is reached
    } catch (error) {
      //console.error(error);
    }
    this.$vs.loading.close();
  }

  async exportSearch() {
			const queryParameters = {
        sort: [{
          field: this.currentSortKey,
          order: this.currentSortDirection,
        }],
        search: {
          ...this.filter,
          $or: this.exportFields.filter(field => field.kind !== 'relation' && field.kind !== 'action').map(field => ({
            [field.key]: {
              $cont: this.currentSearchTerm,
            },
          })),
        },
        join: this.entityDescription.filter((fieldDescription: any) => fieldDescription.kind === 'relation' && this.exportFields.find(field => fieldDescription.key === field.key || fieldDescription.key === field.join)).map((fieldDescription: any) => ({ field: fieldDescription.key })),
      };

    this.$vs.loading();
    try {
      let exportData = await this.model.search(queryParameters);      
      if (!exportData.length) {
				exportData = exportData.data;
			}
      if (!exportData.length) {
        this.$vs.loading.close();
				return;
			}
      const fieldsToExport = this.exportFields;
			// replace header names and translate select options
			const xlsData = exportData.map((row: any) => fieldsToExport.reduce((processedRow, field) => ({
				...processedRow,
				[field.name]: this.getFieldContent(field, field.key, row),
			}), {}));
			const exportWS = XLSX.utils.json_to_sheet(xlsData, { header: fieldsToExport.map(field => field.name) });
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, exportWS, 'Relatório');
			XLSX.writeFile(wb, 'relatorio.xlsx');

    } catch (error) {
      //console.error(error);
    }
    this.$vs.loading.close();
  }

  async handleChangePage(page: number) {
    this.currentPage = page;
    await this.handleSearch(this.currentSearchTerm);
  }

  async handleSort(key: string, direction: string | null) {
    if (direction) {
      this.currentSortDirection = direction.toUpperCase();
      this.currentSortKey = key;
    } else {
      this.currentSortDirection = "ASC";
      this.currentSortKey = ((this.tableFields.find(field => field.defaultSort) || this.tableFields[0]) || {}).key;
    }
    this.handleSearch(this.currentSearchTerm);
  }

  @Watch("selectedRows")
  rowsChanged(newRows: any, oldRows: any) {
    if (this.multiple !== false) {
      this.$emit("rowsSelected", newRows);
      return;
    }
    if (newRows && newRows.id !== oldRows.id) {
      this.$router.push(`${this.$router.currentRoute.path}/${newRows.id}`);
    }
  }

  create() {
    this.$router.push(`${this.$router.currentRoute.path}/novo`);
  }

  runAction(event: any, action: any, entityData: any) {
    event.stopPropagation();
    action(entityData);
  }

  async refresh() {
    if (!this.currentSortKey) { // initialize sorting parameters if necessary
      await this.handleSort("", null);
    } else { // otherwise perform an ordinary search
      await this.handleSearch(this.currentSearchTerm);
    }
  }
}
